/**
 * Minimum number of characters required before triggering search functionality.
 * This ensures search is only performed when the user has entered a meaningful query.
 */
export const MIN_SEARCH_LENGTH = 3;

/**
 * Maximum length for search input to prevent overly long URLs and potential issues.
 */
export const MAX_SEARCH_LENGTH = 200;

/** Maximum search hits from `sm` until below `md`, and from `lg` (five-column grid) up. */
export const SEARCH_RESULTS_MAX = 10;

/** Narrow viewports below Tailwind `sm`: 3-column grid, at most this many hits. */
export const SEARCH_RESULTS_MAX_NARROW = 9;

/** From Tailwind `md` (4-column grid) and up: two full rows of four. */
export const SEARCH_RESULTS_MAX_MD = 8;
